export class AdminService {
  constructor($http) {
    this.http = $http;
  }

  albumphotosList(page, limit){
    return this.http.get(`/api/admin/albumphotos/list/${page}/${limit}`);
  }
}
